import { useMutation, useQueryClient } from 'react-query';
import { ExperimentTemplatePreview } from '@experiment-details/types';
import { expDetailsTemplateKeys } from '../api/exp-details-template-key-factory';
import { removeExpDetailsTemplate } from '../api/expDetailsTemplateApi';
import useExpDetailsRouteParams from '../useExpDetailsRouteParams';

type RemoveTemplateData = {
  templateId: string;
  projectId: string;
};

export default function useRemoveExpDetailsTemplate() {
  const queryClient = useQueryClient();
  const { projectId, experimentKey } = useExpDetailsRouteParams();

  return useMutation(
    (data: RemoveTemplateData) => {
      return removeExpDetailsTemplate({
        templateId: data.templateId,
        projectId: data.projectId
      });
    },
    {
      onMutate: async data => {
        const listQueryKey = expDetailsTemplateKeys.templateList(projectId);

        await queryClient.cancelQueries(listQueryKey);

        const prevData: ExperimentTemplatePreview[] =
          queryClient.getQueryData(listQueryKey) || [];

        queryClient.setQueryData(listQueryKey, [
          ...prevData.filter(
            oldTemplate => oldTemplate.templateId !== data.templateId
          )
        ]);

        return { prevData };
      },
      onError: (e, _, context) => {
        queryClient.setQueryData(
          expDetailsTemplateKeys.templateList(projectId),
          context?.prevData
        );
      },
      onSuccess: async () => {
        await queryClient.invalidateQueries(
          expDetailsTemplateKeys.templateList(projectId),
          {
            refetchInactive: true
          }
        );
        await queryClient.invalidateQueries(
          expDetailsTemplateKeys.personalTemplate(experimentKey, projectId),
          {
            refetchInactive: true
          }
        );
      }
    }
  );
}
